import { JSX } from 'react';
import reactStringReplace from 'react-string-replace';
import XRegExp from 'xregexp';

import { ExternalLink } from '../Clickables/ExternalLink/ExternalLink';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';

import { TagUser } from './TagUser';

export interface IProps {
  id: string; // A unique ID, used to generate unique keys for React.
  text: string;
  url?: string;
}

interface IEscapeCharacters {
  dot: string;
  comma: string;
  colon: string;
  semicolon: string;
  [key: string]: string;
}

const ESCAPE_CHARACTERS: IEscapeCharacters = {
  dot: '.',
  comma: ',',
  colon: ':',
  semicolon: ';',
};

const constructHashtagParameter = (tag: string): string => {
  const dotIndex = tag.indexOf('.');
  let result = tag.split('#').join('');

  result = dotIndex > -1 ? result.substring(0, dotIndex) : result;
  Object.keys(ESCAPE_CHARACTERS).forEach((objKey: string) => {
    const index = result.lastIndexOf(ESCAPE_CHARACTERS[objKey]!);
    // replace for example dot if sentence ends with hashtag + dot

    result = `${result.substring(0, index)}${result.substring(index + 1)}`;
  });

  return result;
};

export const TagContent = ({ id, text, url = '/' }: IProps) => {
  const renderHashtag = (hashtag: string, key: string): JSX.Element | string => {
    return (
      <InternalLink key={`tag-${id}-${key}`} to={`${url}${constructHashtagParameter(hashtag)}`}>
        {hashtag}
      </InternalLink>
    );
  };

  // Convert tags in the text to links
  const textWithTags = reactStringReplace(
    text,
    XRegExp('([#|＃][\\w]+(?!\\p{L}))', 'g'),
    (match, i) => {
      return renderHashtag(match, i.toString());
    },
  );

  // Convert the users in the text to links (this includes the text with tags above)
  const textWithUsers = reactStringReplace(textWithTags, /(@[a-zA-Z0-9_._-]+)/g, match => (
    <TagUser userTag={match} key={`user-${id}-${match}`} />
  ));

  // Convert all the links strings to anchor tags
  const withLinks = reactStringReplace(textWithUsers, /(https?:\/\/\S+)/g, (match, i) => (
    <ExternalLink
      key={`link-${id}-${match}-${i}`}
      href={match}
      target="_blank"
      rel="noopener noreferrer"
    >
      {match}
    </ExternalLink>
  ));
  // @ts-ignore - ReactNodeArray return type works fine with JSX.Element
  return withLinks;
};
